export default __webpack_public_path__ + "static/media/赛马会_white.9d2ee5c3.jpg";